import { Component, OnInit, Injector, Input, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UiEngineComponent } from 'src/modules/base/components/ui-engine/ui-engine.component';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-report-data-table',
    templateUrl: './report-data-table.component.html',
    styleUrls: ['./report-data-table.component.scss'],
    standalone: false
})
export class ReportDataTableComponent extends UiEngineComponent implements OnInit {
  @Input() input: any;
  dynamic_header: any;
  callGRID: boolean = false;
  setData: boolean = false;
  dynamicHeaderLoaded: boolean = false;
  headerKey: any;
  mapKey: any;
  sub: any;
  @ViewChild("datagrid") datagrid: ElementRef;
  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public modal: BsModalService
  ) {
    super(injector, router, route, modal);
    //this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit() {
    // 198848: warm the shared expiry-format config (UtilService) - MIS list columns such as the ledger expiry
    // are formatted once per data load, so it must be known before the first rows arrive; one cached call
    this.utilService.loadExpiryDateFormat().subscribe();
    this.sub = this.route.params.subscribe(res => {
      if (this.input != undefined) {
        if (typeof this.input == 'object') {
          this.resourcename = this.input.resource;
          this.filter = this.input.filter;
          this.showGridOnly = true;
        } else {
          this.resourcename = this.input;
          this.showGridOnly = true;
        }
      }
      this._currentData.renderView = false;
      setTimeout(() => {
        super.ngOnInit();
        this.dynamicHeaderLoaded = false;
      });


    });
  }
  initCurrentData() {
    super.initCurrentData();
    this._currentData.renderView = true;
  }

  persistGrid() {
    if (this._currentData.origArhiveConfig != undefined) {
      return false;
    }
    if (this._currentData && this._currentData["archiveConfig"] != undefined && this._currentData["archiveConfig"]["applied"] != undefined && this._currentData["archiveConfig"]["applied"]) {
      if (this._currentData && this._currentData["archiveConfig"] != undefined && this._currentData["archiveConfig"]["applied"] && !this._currentData["archiveConfig"]["list"]) {
        this.dynamicHeaderLoaded = false;
      }
      return false;
    }
    return true;
  }

  getDataForCrudOperationFn(resouceDef) {
    super.getDataForCrudOperationFn(resouceDef);
    if (this._currentData && this._currentData.default_filter != undefined && this._currentData.default_filter) {
      this.callGRID = true;
      this.setData = true;
    }
  }

  getDynamicHeader() {
    this.dynamicHeaderLoaded = true;
    if (this._currentData && this._currentData.resouceDef && this._currentData.resouceDef.list) {
      this.dynamic_header = this._currentData.resouceDef.list.dynamic_header;
      if (this.dynamic_header) {
        let obj = {
          query_id: this.dynamic_header.datasource.query_id,
          args: this.dynamic_header.datasource && this.dynamic_header.datasource.args ? this.dynamic_header.datasource.args : '',
        }
        if (this.dynamic_header.projectionKeys) {
          obj['projectionKeys'] = this.dynamic_header.projectionKeys;
        }
        if (this.dynamic_header && this.dynamic_header.datasource) {
          this.baseService.getData(obj, "", this.dynamic_header.datasource.resource, this.dynamic_header.datasource.application, this.dynamic_header.datasource.query_id).subscribe(response => {
            if (response.errCode == 0 && response.resource && response.resource.length > 0) {
              let entry;
              let entry1;
              if (this.dynamic_header.setDynamic != undefined && this.dynamic_header.setDynamic) {
                this.setDynamicObj(response.resource);
              }
              else {
                response.resource.forEach(data => {
                  entry = {
                    heading: data[this.dynamic_header.getterKey], //getterKey
                    order: this._currentData.currentListFields.length + 1,
                    name: data[this.dynamic_header.getterValue], //getterValue
                    disabled: false,
                    type: this.dynamic_header.type ? data[this.dynamic_header.type] : 'specialArray',
                    getterArrayKey: this.dynamic_header.setterData,
                    format: this.dynamic_header.mapping && this.dynamic_header.mapping.format1 ? this.baseService.buildDyanamicStr(this.dynamic_header.mapping.format1, { data: data }) : '',
                    setterKey: this.dynamic_header.setterKey,
                    value: this.dynamic_header.setterValue,
                    dynamic_column: true,
                    hidden: false,
                    selected: true
                  }
                  if (this._currentData.resouceDef.list && this._currentData.resouceDef.list.dynamic_columns) {
                    entry['order'] = this._currentData.resouceDef.list.dynamic_columns.find(x => x.id == entry.name) ? this._currentData.resouceDef.list.dynamic_columns.find(x => x.id == entry.name)["o"] : entry.order
                  }
                  if (this.dynamic_header && this.dynamic_header.mapping && this.dynamic_header.mapping.key) {
                    entry1 = {
                      heading: data['type'], //getterKey
                      order: this._currentData.currentListFields.length + 1,
                      name: data[this.dynamic_header.getterValue] + this.dynamic_header.mapping.key, //getterValue
                      disabled: false,
                      type: this.dynamic_header.type ? data[this.dynamic_header.type] : 'composite',
                      getterArrayKey: this.dynamic_header.setterData,
                      setterKey: this.dynamic_header.setterKey,
                      format: this.baseService.buildDyanamicStr(this.dynamic_header.mapping.format, { data: data }),
                      value: this.dynamic_header.mapping.key,
                      dynamic_column: true,
                      hidden: false,
                      selected: true
                    }
                    if (entry1['type'] == 'String') {
                      entry1['type'] = undefined;
                    }
                    if (this._currentData.resouceDef.list && this._currentData.resouceDef.list.dynamic_columns) {
                      entry1['order'] = this._currentData.resouceDef.list.dynamic_columns.find(x => x.id == entry1.name) ? this._currentData.resouceDef.list.dynamic_columns.find(x => x.id == entry1.name)["o"] : entry1.order
                    }
                  }
                  if (entry['type'] == 'String') {
                    entry['type'] = undefined;
                  }
                  if (this._currentData.currentListFields.some(code => code.name == entry.name)) {
                    console.log("Inside If");
                  } else {
                    // this.communicationService.dynamicColumns$.next(entry);

                    this._currentData.currentListFields.push(entry);
                    if (this.dynamic_header && this.dynamic_header.mapping && this.dynamic_header.mapping.key) {
                      this._currentData.currentListFields.push(entry1);
                    }
                  }
                });
              }
              this._currentData.currentListFields = this._currentData.currentListFields.sort((a, b) => { return a.order - b.order });
              this.storageService.setSessionStorageData("dynamic_header_config", this._currentData.currentListFields, () => { });
              this.setDynamicData();
              this.setData = true;
              this.callGRID = true;
            }
          });
        }
      } else {
        this.callGRID = true;
      }
    } else {
      this.callGRID = true;
    }
  }
  getSummaryResponse(event: any) {
    if (event && event.data) {
      this._currentData.summaryResponse = event.data;
    }
  }

  setDynamicObj(response) {
    let entry;
    response.forEach(data => {
      entry =
      {
        "heading": data[this.dynamic_header.getterKey],
        "card_tag": null,
        "order": this._currentData.currentListFields.length + 1,
        "type": "composite",
        "format": "fn=function(item){return " + "item.extra_data" + "[" + "'" + data[this.dynamic_header.getterKey] + "'" + "]}",
        "name": "extra_data,extra_data." + "" + data[this.dynamic_header.getterKey] + "" + ""
      }
      this._currentData.currentListFields.push(entry);
    });
  }

  getAmountAPI(gridData, datasource, callback = null) {
    if (datasource.args)
      gridData['args'] = this.baseService.buildDyanamicStr(datasource.args, '')
    gridData['query_id'] = datasource.query_id;
    if (gridData['projectionKeys']) { delete gridData['projectionKeys'] }
    if (datasource.hasOwnProperty('action_name'))
      if (this.rolePermissionService.checkAccessPermission(datasource.action_name, datasource.resource, datasource.application)) {
        gridData['filter'] += ",treatingDoctorId:" + this.appService.getCurrentUser().user_id
      }
    if (gridData.args != undefined && gridData.args.includes("noCount:1")) {
      //do nothing
    } else if (datasource.noCount == false) { }
    else if (gridData.args != undefined && !gridData.args.includes("noCount:1")) {
      gridData.args = gridData.args + ",noCount:1"
    }
    else {
      gridData.args = "noCount:1"
    }
    this.applyArchivePoicy(gridData, true);
    let obj = {};
    if (this._currentData.isDownload != undefined && this._currentData.isDownload) {
      obj = { catchError: true };
      delete this._currentData.isDownload;
    }
    this.baseService.getData(gridData, "", datasource.resource, datasource.application, undefined, obj).subscribe(
      (data: any) => {
        if (data.errCode == -1) {
          this.alerts.error(data.message);
          if (callback)
            callback(false);
        }
        else if (data.errCode == 504) {
          if (callback)
            callback(false);
        }
        else if (data && data.resource && data.resource.length > 0) {
          let arr = [];
          this._currentData.amountType = datasource.type;
          this.storageService.setSessionStorageData("summary_config", { data: data.resource, key: this._currentData.resouceDef.list.amountResource.datasource }, () => { });
          if (datasource.keys == undefined && datasource.type == 'table' && datasource.fields) {
            this._currentData.amountFields = datasource.fields;
            this._currentData.amountDatasource = data;
            this._currentData.amountCall = true;
            // this.storageService.setSessionStorageData("summary_config",{data:this._currentData.amountDatasource,key:datasource.type},() => {});
          } else if (datasource.keys == undefined && datasource.type == 'multiple') {
            this.headerKey = datasource.headerKey;
            this.mapKey = datasource.mapKey;
            this.getDataAmount(datasource.type, data, arr, callback);
          } else if (datasource.keys == undefined && datasource.type == 'multiple_array') {
            this.headerKey = datasource.headerKey;
            this.mapKey = datasource.mapKey;
            this.getDataAmount(datasource.type, data, arr, callback);
          } else if (datasource.keys && typeof (datasource.keys[0]) == 'string') {
            let resp = data.resource[0][datasource.keys[0]];
            if (resp && resp != undefined && resp.length > 0)
              this.getDataAmount(resp, data, arr, callback);
          } else if (datasource.keys && typeof (datasource.keys[0]) == 'object' && !datasource.dynamic_keys) {
            this.getDataAmount(datasource.keys[0], data, arr, callback);
          } else if (datasource.dynamic_keys) {
            let s = data.resource[0][datasource.dynamic_keys]
            this._currentData.amountData = Object.keys(s).map(x => { return { key: x, value: s[x] } })
            this._currentData.amountCall = false;
            this._currentData.dynamic_keys = true;
            this.getDataAmount(this._currentData.amountData, data, arr, callback);
          }
          else if (datasource.type == 'key_value') {
            let s = data.resource
            if (this._currentData && this._currentData.resouceDef && this._currentData.resouceDef.summaryinvisibleFields) {
              s = s.filter(x => this._currentData.resouceDef.summaryinvisibleFields.includes(x[datasource.key]));
            }
            // if(this._currentData && this._currentData.resouceDef && this._currentData.resouceDef.currency_type){
            //   s = this._currentData.resouceDef.currency_type.find(x=>x.id == x[datasource.key]);
            // }
            this._currentData.amountData = s.map((x, index) => {
              return {
                key: x[datasource.key], value: x[datasource.value], order: this._currentData.resouceDef.summarySequence && this._currentData.resouceDef.summarySequence.find(x => x.id == x[datasource.key])
                  ? this._currentData.resouceDef.summarySequence.find(x => x.id == x[datasource.key])["o"] : index + 1
              }
            })
            if (datasource.sorting)
              this._currentData.amountData.sort((a, b) => a.key.localeCompare(b.key))
            this._currentData.amountCall = true;
            this._currentData.dynamic_keys = true;
          }
        } else {
          this._currentData.amountData = [];
          this._currentData.amountCall = false;
        }
        this.loader.hideSpinner();
      }, (err) => { console.log(err) });
  }


  getDataAmount(resp, data, arr, callback) {
    if (data.resource && data.resource.length > 0) {
      let item = data.resource[0];
      if (resp == 'multiple' || resp == 'multiple_array') {
        let value = data.resource;
        if (resp == "multiple") {
          value = value.map((element) => {
            return {
              ...element, [this._currentData.resouceDef.list.amountResource.datasource.mapKey]:
                Object.keys(element[this._currentData.resouceDef.list.amountResource.datasource.mapKey]).map((y, index) => {
                  return {
                    key: y,
                    value: element[this._currentData.resouceDef.list.amountResource.datasource.mapKey][y],
                    order: index + 1,
                  }
                })
            }
          })
        }
        if (this._currentData && this._currentData.resouceDef && this._currentData.resouceDef.summaryinvisibleFields) {
          value = value.map((element) => {
            return {
              ...element, [this._currentData.resouceDef.list.amountResource.datasource.mapKey]:
                element[this._currentData.resouceDef.list.amountResource.datasource.mapKey]
                  .filter(x =>
                    !this._currentData.resouceDef.summaryinvisibleFields.includes(element[this._currentData.resouceDef.list.amountResource.datasource.headerKey] + "_" + x["key"]
                    ))
            }
          });
        }
        value = value.map((element) => {
          return {
            ...element,
            [this._currentData.resouceDef.list.amountResource.datasource.mapKey]:
              element[this._currentData.resouceDef.list.amountResource.datasource.mapKey].map((y, index) => {
                return {
                  ...y, "order":
                    this._currentData.resouceDef.summarySequence &&
                      this._currentData.resouceDef.summarySequence.find(key => element[this._currentData.resouceDef.list.amountResource.datasource.headerKey] + "_" + y['key'] == key.id)
                      ? this._currentData.resouceDef.summarySequence.find(key => element[this._currentData.resouceDef.list.amountResource.datasource.headerKey] + "_" + y['key'] == key.id)["o"] : index + 1,
                }
              })
          }
        });
        value = value.map((element) => {
          return {
            ...element,
            [this._currentData.resouceDef.list.amountResource.datasource.mapKey]:
              element[this._currentData.resouceDef.list.amountResource.datasource.mapKey].map((y, index) => {
                return {
                  ...y, "currency_type":
                    this._currentData.resouceDef.currency_type &&
                      this._currentData.resouceDef.currency_type.find(key => element[this._currentData.resouceDef.list.amountResource.datasource.headerKey] + "_" + y['key'] == key.id)
                      ? this._currentData.resouceDef.currency_type.find(key => element[this._currentData.resouceDef.list.amountResource.datasource.headerKey] + "_" + y['key'] == key.id)["v"] : false,
                }
              })
          }
        });
        arr = value;
      } else if (typeof (resp) == 'object' && !Array.isArray(resp)) {
        var that = this;
        Object.keys(resp).forEach(function (key, index) {
          let obj = {};
          if (that._currentData && that._currentData.resouceDef && that._currentData.resouceDef.summaryinvisibleFields) {
            if (that._currentData.resouceDef.summaryinvisibleFields.includes(key) || that._currentData.resouceDef.summaryinvisibleFields.includes(resp[key])) {
              return;
            }
          }
          if (that._currentData && that._currentData.resouceDef && that._currentData.resouceDef.currency_type) {
            if (that._currentData.resouceDef.currency_type.find(x => x.id == key)["v"]) {
              obj['currency_type'] = true;
            }
          }
          obj['order'] = that._currentData.resouceDef.summarySequence && that._currentData.resouceDef.summarySequence.find(key => key.id == key)
            ? that._currentData.resouceDef.summarySequence.find(key => key.id == key)["o"] : index + 1;
          obj['key'] = key;
          obj['value'] = item[resp[key]] == undefined ? eval(resp[key])(item) : item[resp[key]];
          arr.push(obj);
        });
      } else {
        resp.map((object, index) => {
          let obj = {};
          if (this._currentData && this._currentData.resouceDef && this._currentData.resouceDef.summaryinvisibleFields) {
            if (this._currentData.resouceDef.summaryinvisibleFields.includes(Object.values(object)[0])) {
              return;
            }
          }
          if (this._currentData && this._currentData.resouceDef && this._currentData.resouceDef.currency_type) {
            if (this._currentData.resouceDef.currency_type.find(x => x.id == Object.values(object)[0])["v"]) {
              obj['currency_type'] = true;
            }
          }
          obj['order'] = this._currentData.resouceDef.summarySequence && this._currentData.resouceDef.summarySequence.find(key => key.id == Object.values(object)[0])
            ? this._currentData.resouceDef.summarySequence.find(key => key.id == Object.values(object)[0])["o"] : index + 1;
          obj['key'] = Object.values(object)[0],
            obj['value'] = Object.values(object)[1]
          arr.push(obj);
        });
      }
      if (callback) {
        callback(arr);
      } else {
        this._currentData.amountData = arr;
        this._currentData.amountCall = true;
      }
      console.log("this._currentData.amountData ", this._currentData.amountData);
    }
  }

  downloadAll() {
    this._currentData.gridData.page_size = 0;
    let amountData: any;
    if (this._currentData.gridData.page_no)
      delete this._currentData.gridData.page_no;
    // if(this._currentData.gridData.filter)
    //   delete this._currentData.gridData.filter;
    if (this._currentData.resouceDef.list.amountResource) {
      this.getAmountAPI(this._currentData.gridData, this._currentData.resouceDef.list.amountResource.datasource, (response) => {
        if (response) {
          amountData = response;
          this.setDownloadData(amountData);
        }
      });
    } else {
      this.setDownloadData(amountData);
    }
  }

  setDownloadData(amountData) {
    this.loader.showSpinner();
    if (this._currentData.currentListFields && this._currentData.currentListFields.length > 0) {
      let gridInfo = [];
      var fieldsClone = JSON.parse(JSON.stringify(this._currentData.currentListFields));
      var i = 0;
      for (let singleField of fieldsClone) {
        if (!singleField.hidden) {
          i++;
          gridInfo.push({
            heading: singleField.heading,
            setterKey: singleField.setterKey,
            type: (singleField.type != undefined) ? singleField.type : "string",
            name: singleField.name,
            format: (singleField.format != undefined) ? btoa(singleField.format) : ""
          })
        }
      }
      let action_obj = {
        "action": "download",
        "items": {
          "permission_required": false,
          "file_data": {
            "action": "download",
            "file_type": "xlsx",
            "gridInfo": gridInfo
          }
        }
      }
      if (amountData != undefined) {
        action_obj.items.file_data['amount'] = amountData;
      }
      super.onBulkActionClicked(action_obj);
    }
  }

  getAmountInfo() {
    this.loader.showSpinner();
    this.getAmountAPI(this._currentData['resFromGrid'], this._currentData.resouceDef.list.amountResource.datasource);
  }

  bindGrid(resource?, application?, type?, queryId?, printInfo?) {
    this.storageService.removeSesssionData("summary_config");
    super.bindGrid(resource, application, type, queryId, printInfo, (response) => {
      if (response && this._currentData.resouceDef.list.amountResource) {
        this._currentData['resFromGrid'] = response;
        this._currentData.amountCall = false;
        try {
          if (response.search != undefined && response.search && !response.eq_search) {
            this._currentData['hideViewSummary'] = true;
          }
          else {
            this._currentData['hideViewSummary'] = false;
          }
        } catch (error) {
        }
        // this.getAmountAPI(response, this._currentData.resouceDef.list.amountResource.datasource);
      }
      if (this._currentData && this._currentData.dataList.length == 0) {
        if (this.datagrid) {
          this.datagrid['items'] = [];
        }
      }
      // recent patient history in emr click  method
      if (this._currentData?.dataList?.resource?.length > 0 && this._currentData?.resouceDef?.config && this._currentData?.dataGridConfig && this._currentData?.resouceDef?.config?.gridPopup && this._currentData?.resouceDef?.config?.gridPopupApi) {
        this._currentData.dataGridConfig.gridPopupIcon = this?._currentData?.resouceDef?.config?.gridPopupIcon
      }
      if (this._currentData && this._currentData.resouceDef && this._currentData.resouceDef.list && this._currentData.resouceDef.list.dynamic_header) {
        this.setData = false;
        if (this.dynamicHeaderLoaded == true) {
          if (this.dynamic_header.setterData != undefined)
            this.setDynamicData();
          this.callGRID = true;
          this.setData = true;
        }
        else
          this.getDynamicHeader();
      } else {
        this.callGRID = true;
        this.setData = true;
      }
    });
  }

  onBulkActionClicked(action_obj) {
    if (this._currentData != undefined && this._currentData.resouceDef.list.amountResource && this._currentData.amountData != undefined && this._currentData.amountData) {
      action_obj.items.file_data.amount = this._currentData.amountData;
      super.onBulkActionClicked(action_obj);
    }
    //chunk download no need of amount call
    else if (action_obj != undefined && action_obj.items != undefined && action_obj.items.file_data != undefined && action_obj.items.file_data.chunk_download != undefined && action_obj.items.file_data.chunk_download) {
      super.onBulkActionClicked(action_obj);
    }
    else if (this._currentData != undefined && this._currentData['resFromGrid'] != undefined && this._currentData.resouceDef && this._currentData.resouceDef.list && this._currentData.resouceDef.list.amountResource) {
      this._currentData['isDownload'] = true;
      this.getAmountAPI(this._currentData['resFromGrid'], this._currentData.resouceDef.list.amountResource.datasource, (cb) => {
        if (cb) {
          action_obj.items.file_data.amount = cb;
          super.onBulkActionClicked(action_obj);
        }
        //even if amount api fails we will not stop downloading
        else {
          super.onBulkActionClicked(action_obj);
        }
      });
    } else if (this._currentData != undefined && this._currentData.summaryResponse != undefined && this._currentData.summaryResponse != null) {
      action_obj.items.file_data.amount = this._currentData.summaryResponse;
      super.onBulkActionClicked(action_obj);
    }
    else if (this._currentData && this._currentData.summary && this._currentData.summary.blocks) {
      this._currentData['isDownload'] = true;
      this.getAmountAPI(this._currentData.gridData, this._currentData.resouceDef.summary.datasource, (cb) => {
        if (cb) {
          action_obj.items.file_data.amount = cb;
          super.onBulkActionClicked(action_obj);
        }
        //even if amount api fails we will not stop downloading
        else {
          super.onBulkActionClicked(action_obj);
        }
      });
    }
    else {
      super.onBulkActionClicked(action_obj);
    }
    // 
  }

  activeTab(key) {
    this.dynamicHeaderLoaded = false;
    this._currentData.amountData = undefined;
    this._currentData.amountDatasource = undefined;
    this._currentData.amountCall = false;
    super.activeTab(key);
    this._currentData.currentListFields = []
  }
  setDynamicData() {
    if (this._currentData != undefined && this._currentData.dataList != undefined && this._currentData.dataList.resource != undefined) {
      this._currentData.dataList.resource.forEach(element => {
        if (element[this.dynamic_header.setterData]) { //setterData
          element[this.dynamic_header.setterData].forEach(subelement => {
            element[subelement[this.dynamic_header.setterKey]] = element.hasOwnProperty(subelement[this.dynamic_header.setterKey]) ? element[subelement[this.dynamic_header.setterKey]] + subelement[this.dynamic_header.setterValue] : subelement[this.dynamic_header.setterValue];
          });
        }
      })
    }
  }

  applyStyle() {
    if (this._currentData.resouceDef.list.amountResource.datasource.hasOwnProperty("single_line")) {
      if (this._currentData.resouceDef.list.amountResource.datasource.single_line == false) {
        return { 'flex-direction': 'column' }
      } else {
        return {}
      }
    } else {
      return { 'flex-direction': 'column' }
    }
  }

  toggleTabView(event) {
    //console.log('clicked');
    event.currentTarget.parentElement.parentElement.classList.toggle('expand');
  }

  ngOnDestroy() {
    if (this.sub != undefined && this.sub.unsubscribe != undefined) {
      this.sub.unsubscribe();
    }
    super.ngOnDestroy();
  }
}
